<template>
  <div id="content">
    <h2 class="title">公司部分荣誉证书</h2>
    <div class="con">
      <el-row :gutter="20">
        <el-col
          v-for="(x, i) in list"
          :key="i"
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
          :xl="6"
        >
          <ImageCard v-bind="x"></ImageCard>
        </el-col>
      </el-row>
    </div>

    <h2 class="title">其他证件</h2>
    <div class="con">
      <el-row :gutter="20">
        <el-col
          v-for="(x, i) in others"
          :key="i"
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
          :xl="6"
        >
          <ImageCardCover v-bind="x"></ImageCardCover>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style scoped>
#content {
  overflow: hidden;
}
.con {
  width: 100%;
  float: left;
}
.space {
  width: 100%;
  float: left;
}
.el-row {
  padding: 0 16px;
}
.title {
  height: 44px;
  background-color: #409eff;
  color: #ffffff;
  line-height: 44px;
  padding: 0 32px;
  font-size: 20px;
  margin-bottom: 32px;
  width: 100%;
  float: left;
}
</style>

<script>
import ImageCard from "@/components/ImageCard.vue";
import ImageCardCover from "@/components/ImageCardCover.vue";

export default {
  components: {
    ImageCard,
    ImageCardCover
  },
  data() {
    return {
      list: [],
      others: []
    };
  },
  created() {
    //生命周期vue实例创建后,做数据安排
    let arr = [
      {
        num: 12,
        title: "高新技术企业"
      },
      {
        num: 8,
        title: "中国驰名商标"
      },
      {
        num: 17,
        title: "辽宁省省级企业技术中心"
      },
      {
        num: 21,
        title: "大连市工程实验室"
      },
      {
        num: 28,
        title: "绕组温控器获科学技术进步奖"
      },
      {
        num: 6,
        title: "国家重点新产品证书"
      },
      {
        num: 20,
        title: "国家重点新产品证书"
      },
			{
				num: 31,
				title: "辽宁省优秀新产品奖励证书"
			},
      {
        num: 4,
        title: "辽宁省中小企业专精特新产品"
      },
      {
        num: 7,
        title: "中国百佳诚信投标企业"
      },
      {
        num: 18,
        title: "中国电器工业十大知名品牌"
      },
      {
        num: 14,
        title: "大连市科学技术奖 一等"
      },
      {
        num: 16,
        title: "纳税信用等级AA级别"
      },
      {
        num: 27,
        title: "光声光谱获专精特新奖"
      },
      {
        num: 1,
        title: "大连市专利奖 二等"
      },
      {
        num: 24,
        title: "入围中国创新创业大赛总决赛"
      },
      {
        num: 25,
        title: "光纤测温获专精特新奖"
      },
      {
        num: 26,
        title: "大连市十佳环境友好企业"
      },
      {
        num: 22,
        title: "2019中国创新科技品牌"
      },
      {
        num: 23,
        title: "2019中国科技创新领军人物"
      },
      {
        num: 30,
        title: "国家知识产权优势企业"
      },
      {
        num: 29,
        title: "辽宁电力科学技术进步奖"
      }
    ];
    let res = [];
    for (var i in arr) {
      res.push({
        path: require("@/assets/company/aptitude" + arr[i].num + ".jpg"),
        title: arr[i].title
      });
    }
    this.list = res;

    let arr_2 = [
      "营业执照",
      "国网潜在投标人",
      "质量管理体系认证证书",
      "环境管理体系认证证书",
      "职业健康安全管理体系认证证书",
      "知识产权管理体系认证证书",
      "出口欧盟安全认证认证",
      "AAA级信用企业",
      "AAA级重服务守信用企业",
      "AAA级质量服务诚信企业",
      "AAA级重合同守信用企业",
      "AAA级诚信企业家",
      "AAA级重质量守信用企业"
    ];
    let res_2 = [];
    for (let i = 0; i < arr_2.length; i++) {
      res_2.push({
        path: require("@/assets/others/o" + i + ".jpg"),
        title: arr_2[i]
      });
    }
    this.others = res_2;
  }
};
</script>
